import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { BaseModalComponent } from 'src/app/core/base-modal.componant';
import { SessionService } from 'src/app/shared/services/session.service';
import { PriceBandTypes } from 'src/app/simulator-booking/models/price-band-types';
import { PriceBandService } from 'src/app/simulator-booking/services/price-band.service';

@Component({
    selector: 'price-band-create-modal',
    templateUrl: './price-band-create-modal.component.html',
    styleUrl: './price-band-create-modal.component.scss',
    standalone: false
})
export class PriceBandCreateModalComponent extends BaseModalComponent {
  public form = new FormGroup({
    priceBandTypeId: new FormControl('', {
      validators: Validators.required
    }),
    organizationId: new FormControl('', {
      validators: Validators.required
    }),
    createdBy: new FormControl(),
  });

  public priceBandTypes: PriceBandTypes[] = [];

  constructor(private sessionService: SessionService,
    private priceBandService: PriceBandService,
    public dialogRef: MatDialogRef<PriceBandCreateModalComponent>) {
    super();
    this.form.get('organizationId').setValue(this.sessionService.getUser().organizationId);
    this.form.get('createdBy').setValue(this.sessionService.getUserId());
    this.getPriceBandTypes();
  }

  getPriceBandTypes() {
    this.isLoading = true;
    this.priceBandService.getTypes().subscribe({
      next: (result) => this.priceBandTypes = result,
      error: (error) => {
        console.error(error);
        this.isLoading = false;
      },
      complete: () => this.isLoading = false
    });
  }

  submit({ value, valid }) {
    if (valid) {
      this.isLoading = true;
      this.priceBandService.create(value).subscribe({
        next: (result) => {
          if (result !== null || result !== undefined) {
            this.dialogRef.close("save");
          }
        },
        error: (error) => {
          this.isLoading = false;
          this.setError(error, this.form);
          console.error(error);
        },
        complete: () => this.isLoading = false
      });
    }
  }
}
